export default __webpack_public_path__ + "/dist/images/alysei-bg.e94e3dbda81e54e68853a367f6ee1fd0.png";